"use client";

import { c as _c } from "react/compiler-runtime";
import { ChevronRight } from "lucide-react";
import Button from "../ui/buttons";
export default function ReadFullForm() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className="text-18-tamil-700 mb-6 text-1B1B1B">To Read the Full Article</h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex flex-col md:flex-row justify-center gap-4 mb-8"><Button variant="primary" onClick={_temp} className="w-full md:w-[200px] text-18-tamil-700 text-FFFFFF h-[48px] cursor-pointer">Subscribe</Button><Button variant="outline" onClick={_temp2} className="w-full md:w-[200px] text-18-tamil-700 text-012061 h-[48px] cursor-pointer">Login</Button></div>;
    t2 = <p className="text-left text-18-tamil-600 text-1B1B1B mb-6 leading-6">This is a Premium Article, available only to our subscribers. Subscribe today to receive 2000+ articles every month!</p>;
    t3 = <div className="w-full border-b border-2D497E mb-4" />;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="w-full max-w-[852px] h-auto md:h-[305px] mx-auto bg-ECEEF3 p-6 text-center">{t0}{t1}{t2}{t3}<div className="text-left text-18-tamil-600 text-1B1B1B flex items-center gap-2 cursor-pointer">Learn more about Dinamani Subscription<ChevronRight className="w-7 h-7" /></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function _temp2() {}
function _temp() {}